<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <div class="support_tickets_head">
        <button class="secondary_btn"  @click="popupcreateticket=true">Create Ticket</button>
      </div>
      
    <vs-table :data="users"> 
      <template slot="thead">
        <vs-th>
          <span>
              <a
                @click="sortMe('id')"
                v-bind:class="{
                  sort_ascending: sortKeys['id'] == 1,
                  sort_descending: sortKeys['id'] != 1,
                }"
                >Ticket ID</a
              >
            </span>
        </vs-th>
        <vs-th>
         <span>
              <a
                @click="sortMe('website')"
                v-bind:class="{
                  sort_ascending: sortKeys['website'] == 1,
                  sort_descending: sortKeys['website'] != 1,
                }"
                >Subject</a
              >
            </span>
        </vs-th>
        <vs-th>
              <span>
              <a
                @click="sortMe('email')"
                v-bind:class="{
                  sort_ascending: sortKeys['email'] == 1,
                  sort_descending: sortKeys['email'] != 1,
                }"
                >Email</a
              >
            </span>
        </vs-th>
        <vs-th>
         <span>
              <a
                @click="sortMe('name')"
                v-bind:class="{
                  sort_ascending: sortKeys['name'] == 1,
                  sort_descending: sortKeys['name'] != 1,
                }"
                >Name</a
              >
            </span>
        </vs-th>
        <vs-th>
         <span>
              <a
                @click="sortMe('username')"
                v-bind:class="{
                  sort_ascending: sortKeys['username'] == 1,
                  sort_descending: sortKeys['username'] != 1,
                }"
                >User Name</a
              >
            </span>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="tr.id">
            {{tr.id}}
          </vs-td>
          <vs-td :data="tr.website">
            {{tr.website}}
          </vs-td>
          <vs-td :data="tr.email">
            {{tr.email}}
          </vs-td>

          <vs-td :data="tr.name">
            {{tr.name}}
          </vs-td>
          <vs-td :data="tr.username">
            {{tr.username}}
          </vs-td>
          
          <template class="expand-user" slot="expand">
             <div class="expanded_details">
               <div class="write_post">
                 <vs-textarea v-model="textarea" placeholder="Write post here" />
                 <div class="uploads">
                   <vs-upload   @on-success="successUpload" />
                   <div class="upload_actions">
                     <select>
                       <option>STATUS</option>
                       <option>REJECTED</option>
                       <option>APPROVED</option>
                       <option>PENDING</option>
                     </select>
                     <button class="primary_btn">POST</button>
                   </div>
                 </div>
               </div>
               <div class="comments_section">
                  <div class="comments_list">
                      <figure><vs-avatar  size="45px" :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"/></figure>
                      <div class="comments_cnt">
                        <h4>Emerentiana Meicy<span>15 min ago</span></h4>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                      </div>
                  </div>
                  <div class="comments_list">
                      <figure><vs-avatar  size="45px" :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"/></figure>
                      <div class="comments_cnt">
                        <h4>Emerentiana Meicy<span>15 min ago</span></h4>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                        <ul>
                          <li><img src="@/assets/images/pages/graphic-1.png"></li>
                          <li><img src="@/assets/images/pages/graphic-1.png"></li>
                          <li><img src="@/assets/images/pages/graphic-1.png"></li>
                          <li><img src="@/assets/images/pages/graphic-1.png"></li>
                        </ul>
                      </div>
                  </div>
                  <div class="comments_list">
                      <figure><vs-avatar  size="45px" :src="`https://randomuser.me/api/portraits/women/${indextr}.jpg`"/></figure>
                      <div class="comments_cnt">
                        <h4>Emerentiana Meicy<span>15 min ago</span></h4>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                      </div>
                  </div>
               </div>
             </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup class="holamundo" :active.sync="popupcreateticket"  title="New Ticket">
      <div class="createticket_form">
        <form>
         <ul>
           
           <li>
             <div class="form-group">
              <vs-input
              v-validate= "'required'"
              data-vv-validate-on="blur"
              name="Subject"
              label-placeholder="Subject"
              v-model="subject"
              class="w-full"/>
            <span class="text-danger text-sm">{{ errors.first('Subject') }}</span>
            </div>
           </li>
           <div></div>
           
           <li>
             <div class="form-group">
              <vs-input
              v-validate="'required'"
              data-vv-validate-on="blur"
              name="Project"
                        
              
              label-placeholder="Project"
              v-model="project"
              class="w-full"/>
            <span class="text-danger text-sm">{{ errors.first('Project') }}</span>
            </div>
           </li>
           
           <span></span>
          <li></li>
           <li>
             <vs-textarea 
             v-model="textarea"
             name = "Description"
             v-validate = "'min:10'"
             data-vv-validate-on="blur"
             placeholder="Description"
             class="w-full"/>
             
           </li>
         </ul>

        </form>
        <div class="form_actions">
           <vs-upload multiple  automatic action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />
          <button class="close_popup primary_btn" @click="popupcreateticket=false">Create</button>
        </div>
      </div>
      
    </vs-popup>
  </div>
</template>

<script>
export default {
  data:() => ({
    subject: '',
    project: '',
    textarea: '',
    popupcreateticket:false,
    users:[
      {
        'id': 1,
        'name': 'Leanne Graham',
        'username': 'Bret',
        'email': 'Sincere@april.biz',
        'website': 'hildegard.org'
      },
      {
        'id': 2,
        'name': 'Ervin Howell',
        'username': 'Antonette',
        'email': 'Shanna@melissa.tv',
        'website': 'anastasia.net'
      },
      {
        'id': 3,
        'name': 'Clementine Bauch',
        'username': 'Samantha',
        'email': 'Nathan@yesenia.net',
        'website': 'ramiro.info'
      },
      {
        'id': 4,
        'name': 'Patricia Lebsack',
        'username': 'Karianne',
        'email': 'Julianne.OConner@kory.org',
        'website': 'kale.biz'
      },
      {
        'id': 5,
        'name': 'Chelsey Dietrich',
        'username': 'Kamren',
        'email': 'Lucio_Hettinger@annie.ca',
        'website': 'demarco.info'
      },
      {
        'id': 6,
        'name': 'Mrs. Dennis Schulist',
        'username': 'Leopoldo_Corkery',
        'email': 'Karley_Dach@jasper.info',
        'website': 'ola.org'
      },
      {
        'id': 7,
        'name': 'Kurtis Weissnat',
        'username': 'Elwyn.Skiles',
        'email': 'Telly.Hoeger@billy.biz',
        'website': 'elvis.io'
      },
      {
        'id': 8,
        'name': 'Nicholas Runolfsdottir V',
        'username': 'Maxime_Nienow',
        'email': 'Sherwood@rosamond.me',
        'website': 'jacynthe.com'
      },
      {
        'id': 9,
        'name': 'Glenna Reichert',
        'username': 'Delphine',
        'email': 'Chaim_McDermott@dana.io',
        'website': 'conrad.com'
      },
      {
        'id': 10,
        'name': 'Clementina DuBuque',
        'username': 'Moriah.Stanton',
        'email': 'Rey.Padberg@karina.biz',
        'website': 'ambrose.net'
      }
    ],
    sortKeys: {
        email: 1,
        id: 1,
        website:1,
        name:1,
        username: 1
      },
  }),
 
}
</script>
<style  lang="scss">

.con-expand-users {
  .con-btns-user {
        display: flex;
        padding: 10px;
        padding-bottom: 0px;
        align-items: center;
        justify-content: space-between;
        .con-userx {
        display: flex;
        align-items: center;
        justify-content :flex-start;
            .list-icon {
                i{ font-size: .9rem !important;}
            }
        }
    }
}
</style>